const FormLabel = {

  baseStyle: {        
      fontSize: '14px',      
      marginBottom: '3px'
  }
}

export default FormLabel